module.exports = __webpack_public_path__ + "static/media/novoLogo.a595f537.png";